import { axiosAuth } from "js/config/axios-instance";
import {
  GET_EXCHANGE_CODE,
  GET_USER_DATA,
  UPDATE_USER_MEDICAL_INFO,
} from "js/redux/type.js";

export function getUser(succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosAuth.get(
        process.env.REACT_APP_API_BASE_URL + "/user"
      );
      await dispatch({
        type: GET_USER_DATA,
        payload: response.data,
      });
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function updateUserMedicalInfo(data, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosAuth.post(
        process.env.REACT_APP_API_BASE_URL + "/user-update",
        data
      );
      await dispatch({
        type: UPDATE_USER_MEDICAL_INFO,
        payload: {
          ...data,
          medical_info: {
            has_allergies: data.has_allergies,
            allergies: data.allergies,
            has_medication: data.has_medication,
            medication: data.medication,
          },
        },
      });
      succcessCallback && succcessCallback();
      return response;
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function getExchangeCode(data, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosAuth.post(
        process.env.REACT_APP_API_BASE_URL + "/get-exchange-code",
        data
      );
      await dispatch({
        type: GET_EXCHANGE_CODE,
        payload: response.data,
      });
      succcessCallback && succcessCallback();
      return response.data.code;
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}
